//トレプロのそのまま持ってきた
//現状未使用

import { useState } from "react";

export const useInput = (initialValue: any) => {
  const [value, setValue] = useState(initialValue);
  const onChange = (e: { target: { value: any; }; }) => {
    // e.stopPropagation();
    setValue(e.target.value);
  };
  return { value, setValue, onChange };
};
